// 端末ごとの設定(遊ぶときの視点・リプレイの演出カメラ・言語・初回の説明を見たか・チャートから強化を選んだことがあるか chartPicked)。
// 1つのキー senseofdopa.device に JSON でまとめる(前は項目ごとに別のキーだった。古いキーは最初に読んだときに移して消す)。
// 「ずっと続く記録」(DOPA・格納庫・記録)は src/meta/save.js の senseofdopa.save で、こちらとは別。
// localStorage が使えない時(プライベートブラウズなど)は、その回だけ覚える。

const KEY = "senseofdopa.device";
const OLD_KEYS = { camera: "senseofdopa.camera", replayCamera: "senseofdopa.replayCamera", lang: "senseofdopa.lang", tutorialSeen: "senseofdopa.tutorialSeen" };
const OLD_UNUSED = ["senseofdopa.plays"]; // 出撃の回数。視点の解放は save.records.runs を見るようにしたので、もう使わない

let memory = null; // storage が使えない時の控え

export function loadDevice(storage = globalThis.localStorage) {
  try {
    const d = JSON.parse(storage.getItem(KEY));
    if (d && typeof d === "object") return d;
  } catch {}
  return migrate(storage);
}

// 古い項目ごとのキーから1つにまとめる(1回だけ。古いキーは消す)
function migrate(storage) {
  const d = memory || {};
  try {
    for (const [k, old] of Object.entries(OLD_KEYS)) {
      const v = storage.getItem(old);
      if (v != null) {
        d[k] = k === "tutorialSeen" ? true : v;
        storage.removeItem(old);
      }
    }
    for (const old of OLD_UNUSED) storage.removeItem(old);
    if (Object.keys(d).length) storage.setItem(KEY, JSON.stringify(d));
  } catch {}
  memory = d;
  return d;
}

export function getDevice(key, storage) {
  return loadDevice(storage)[key];
}

// value が null なら消す
export function setDevice(key, value, storage = globalThis.localStorage) {
  const d = loadDevice(storage);
  if (value == null) delete d[key];
  else d[key] = value;
  memory = d;
  try {
    storage.setItem(KEY, JSON.stringify(d));
  } catch {}
  return d;
}
